export default __webpack_public_path__ + "static/media/BackButton.bc2f10bf.svg";